import React from 'react';
import { journeySteps } from '../../data/ferringConcept';
export function ExamplePanel() {
  return <div data-id="element-29" data-mp="2hmrvxytxfgbm">
      <h2 className="max-w-3xl text-[36px] font-medium leading-[1.04] tracking-[-0.035em] text-navy md:text-[48px]" data-id="element-30" data-mp="2hmi56912554v">
        One possible way to make a REKOVELLE benefit interactive
      </h2>
      <p className="mt-6 max-w-2xl text-lg leading-relaxed text-navy/65" data-id="element-31" data-mp="2rdmlbc2gyw1a">
        For this prototype, we built a 30–45 second teaser around individualized first-cycle dosing. The HCP answers a simple clinical
        question, explores the challenge for a moment — and the REKOVELLE benefit arrives as the answer.
      </p>
      <p className="mt-4 max-w-2xl text-base leading-relaxed text-navy/55" data-id="element-32" data-mp="23m7cr1k3nihl">
        This prototype is one possible expression of the Snakker model. The final campaign idea, clinical story and execution would be
        developed together with Ferring.
      </p>

      <ol className="mt-8 grid gap-px overflow-hidden rounded-xl border border-navy/10 bg-navy/10 sm:grid-cols-3 lg:grid-cols-6" data-id="element-33" data-mp="3k1ilwrv5t83c">
        {journeySteps.map(s => <li key={s.label} className={`flex flex-col p-4 ${s.highlight ? 'bg-[#f2f6fb]' : 'bg-white'}`} data-id="element-34" data-mp="1w23xpt8yxe4u">
            <span className={`text-sm font-medium leading-snug ${s.highlight ? 'text-ferring' : 'text-navy'}`} data-id="element-35" data-mp="1n3rxcziav1z7">{s.label}</span>
            <span className="mt-1 text-xs leading-snug text-navy/55" data-id="element-36" data-mp="1i5gpuvfh93k5">{s.detail}</span>
          </li>)}
      </ol>

      <p className="mt-8 max-w-2xl text-lg leading-relaxed text-navy/65" data-id="element-37" data-mp="1d6dtdzdkc5ns">
        It starts with the clinical idea, not the product claim —{' '}
        <span className="text-navy" data-id="element-38" data-mp="14da8j60l8qj4">what are we trying to achieve with ovarian stimulation?</span> REKOVELLE then enters naturally as one
        way of approaching that challenge. The same principle could be applied to whichever REKOVELLE benefit Ferring believes is most
        strategically important.
      </p>

      <p className="mt-10 max-w-3xl border-l-2 border-ferring pl-6 text-[26px] font-medium leading-[1.15] tracking-[-0.025em] text-navy md:text-[32px]" data-id="element-39" data-mp="pg9to33hwq22">
        The specific creative execution can change. The principle does not: make the benefit interactive.
      </p>
    </div>;
}